
import {
    defineComponent, PropType, Ref, ref
} from 'vue';
import apartmentEditDialog, { ApartmentForm } from '@/components/view/pm/apartment-edit-dialog';
import { filterEmptyCellValue } from '@/components/common/list';
import { ListData } from './all.type';

export default defineComponent({
    components: {
        apartmentEditDialog
    },
    props: {
        basicInformationData: {
            type: Array as PropType<Array<ListData>>,
            required: true
        },
        basicInformationEditForm: {
            type: Object as PropType<ApartmentForm>,
            required: true
        }
    },
    setup(props, { emit }) {
        const isShowApartmentEditDialog = ref(false);
        const initForm: Ref<ApartmentForm> = ref({
            ID: '',
            AptName: '',
            CallType: 0,
            EnableIpDirect: 0,
            TempKeyPermission: 0,
            LimitCreateQRcode: 0,
            LimitFamilyMember: 0,
            FamilyMemberControl: 0,
            AllowCreateSlaveCnt: '',
            RegisterFaceControl: 1,
            LimitRegisterFace: 0
        });

        const edit = () => {
            isShowApartmentEditDialog.value = true;
            initForm.value.ID = props.basicInformationEditForm.ID;
            initForm.value.AptName = props.basicInformationEditForm.AptName;
            initForm.value.CallType = props.basicInformationEditForm.CallType;
            initForm.value.EnableIpDirect = props.basicInformationEditForm.EnableIpDirect;
            initForm.value.TempKeyPermission = props.basicInformationEditForm.TempKeyPermission;
            initForm.value.LimitCreateQRcode = props.basicInformationEditForm.LimitCreateQRcode;
            initForm.value.LimitFamilyMember = props.basicInformationEditForm.LimitFamilyMember;
            initForm.value.FamilyMemberControl = props.basicInformationEditForm.FamilyMemberControl;
            initForm.value.AllowCreateSlaveCnt = props.basicInformationEditForm.AllowCreateSlaveCnt;
            initForm.value.RegisterFaceControl = props.basicInformationEditForm.RegisterFaceControl;
            initForm.value.LimitRegisterFace = props.basicInformationEditForm.LimitRegisterFace;
        };

        const success = () => {
            emit('updateBasicInformation');
            isShowApartmentEditDialog.value = false;
        };
        return {
            isShowApartmentEditDialog,
            initForm,
            edit,
            success,
            filterEmptyCellValue
        };
    }
});
